<app-back-button></app-back-button>
<div class="header">
  <div class="instituicao-info">
    <div class="name-area">
      <div class="left-area">
        <div class="avatar">
          <p-avatar
            *ngIf="!empresaLogoError && empresaLogoUrl; else defaultEmpresaAvatar"
            [image]="empresaLogoUrl"
            shape="circle"
            size="large"
            (onImageError)="empresaLogoError = true"
          />
          <ng-template #defaultEmpresaAvatar>
            <p-avatar
              [label]="getInitials(vagaDetail?.designacaoFuncao)"
              [icon]="!vagaDetail?.designacaoFuncao ? 'pi pi-briefcase' : undefined"
              shape="circle"
              size="large"
            />
          </ng-template>
        </div>
        <div class="title-header">
          <span class="name">{{vagaDetail?.designacaoFuncao}}</span>
          <div class="info">
            <span> <strong>Presencial</strong></span>
            <span>•</span>
            <span>{{vagaDetail?.remuneracao}} milhões / ano</span>
            <span>•</span>
            <span> <p-tag *ngIf="estadoVagaMap[vagaDetail?.estadoVaga]"
                [severity]="estadoVagaMap[vagaDetail?.estadoVaga].severity"
                [value]="'Vaga ' + estadoVagaMap[vagaDetail?.estadoVaga].label" /> </span>
          </div>
        </div>
      </div>
    </div>
    <div class="contact-info">
      <div class="descrição">
        <p>{{vagaDetail?.descricao}} </p>
      </div>
    </div>
  </div>
  <div class="indicator">
    <div class="avatars">
      <p-avatar-group>
        <p-avatar icon="pi pi-user" size="large" shape="circle" />
        <p-avatar icon="pi pi-user" size="large" shape="circle" />
        <p-avatar icon="pi pi-user" size="large" shape="circle" />
        <p-avatar [label]="'+' + (candidatosCount || 0)" shape="circle" size="large" [style]="{ 'background-color': '#ebebef', color: '#333', 'font-size': '0.9rem' }" />
      </p-avatar-group>
    </div>
    <div class="text">
      <span>{{candidatosCount}} Candidatos</span>
    </div>
  </div>
</div>
<div class="actions">
  <p-button label="Mais detalhes da vaga" icon="pi pi-info-circle" iconPos="right" severity="secondary"
    (onClick)="actionClick(vagaDetail || id)" />

  <p-button label="Cancelar Vaga" icon="pi pi-trash" iconPos="right" severity="danger" [outlined]="true"
    (onClick)="deleteVaga(vagaDetail.id)" />

  <p-button label="Encerrar candidaturas" severity="help" [outlined]="false" />

  <!-- Novo: Baixar Comprovativo -->
  <p-button label="Baixar comprovativo" icon="pi pi-file-pdf" iconPos="right" severity="info" [disabled]="isLoadingProof"
    (onClick)="onGerarComprovativo({ item: { data: { id: vagaDetail.id } } })" />
</div>

<p-tabs [(value)]="activeTab" (valueChange)="onTabClick(+$event)">
  <p-tablist>
    <p-tab [value]="0" style="text-transform: uppercase;">
      <div class="tab-icon">
        <img src="icons/users-check.svg" alt="user Icon" />
      </div>
      Candidaturas
    </p-tab>
    <p-tab value="1" style="text-transform: uppercase;">
      <div class="tab-icon">
        <img src="icons/search-md.svg" alt="Search Icon" />
      </div>
      Profissionais Disponíveis <p-badge value="0" badgeSize="xlarge" severity="info" />
    </p-tab>
    <!-- <p-tab value="2">
        <div class="tab-icon">
          <img src="icons/message-text-square.svg" alt="Feedbacks Icon" />
        </div>
        Feedbacks
      </p-tab> -->
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel [value]="0">
      <div class="list">
        <app-search-bar [showPrimaryBtn]="false" [showFilterBtn]="true" (onFilterBtnClick)="showDialog()"
          (formValueChange)="handleFormValueChange($event)"></app-search-bar>
        <div *ngIf="pagination.data?.length; else noDataTemplate">
          <div class="candidato-item" *ngFor="let candidato of pagination.data; trackBy: trackByUserId">
            <app-card-candidatura *ngIf="candidato" [candidato]="candidato" [profissional]="candidato.profissional"
              [vaga]="vagaDetail" [designacaoFuncao]="candidato?.profissional?.designacaoFuncao"
              [dataCandidatura]="candidato.dataCandidatura"
              [nivelHabilitacao]="candidato?.profissional?.nivelHabilitacao">
            </app-card-candidatura>
          </div>
          <div class="pagination-controls">
            <app-paginator-control [first]="((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)"
              [rows]="pagination.pageSize ?? 10" [totalRecords]="pagination.totalRecords ?? 0"
              (pageChange)="onPageChange($event)">
            </app-paginator-control>
          </div>
        </div>
        <ng-template #noDataTemplate>
          <app-data-void titulo="Nenhuma candidatura encontrada"
            descricao="Ainda não existem candidaturas para exibir."></app-data-void>
        </ng-template>

      </div>
    </p-tabpanel>
    <p-tabpanel [value]="1">
      <div class="list">
        <app-search-bar [showPrimaryBtn]="false" [showFilterBtn]="true" (onFilterBtnClick)="showDialog()"
          (formValueChange)="handleFormValueChange($event)"></app-search-bar>
        <div *ngIf="false; else noDataTemplateProfissional">
          <app-card-profissional *ngFor="let profissional of pagination.data; trackBy: trackByUserId"
            [profissional]="profissional"></app-card-profissional>
        </div>
        <div class="pagination-controls">
          <app-paginator-control [first]="((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)"
            [rows]="pagination.pageSize ?? 10" [totalRecords]="pagination.totalRecords ?? 0"
            (pageChange)="onPageChange($event)">
          </app-paginator-control>
        </div>
        <ng-template #noDataTemplateProfissional>
          <app-data-void titulo="Nenhum profissional encontrado"
            descricao="Ainda não existem profissionais disponíveis para exibir."></app-data-void>
        </ng-template>
      </div>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
<p-toast></p-toast>
<p-confirmdialog>
  <ng-template #message let-message>
    <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700">
      <i [ngClass]="message.icon" class="!text-6xl text-primary-500"></i>
      <p>{{ message.message }}</p>
    </div>
  </ng-template>
</p-confirmdialog>

<p-drawer [(visible)]="showDetalhe" position="right" [style]="{'width': '720px'}"
  styleClass="!w-full md:!w-80 lg:!w-[30rem]">
  <ng-template #headless>
    @if (maisDetalheVagas) {
    <!-- <app-candidatura-detalhe *ngIf="candidaturaSelecionada" [candidatura]="candidaturaSelecionada" (onCloseModal)="showDetalhe=false"></app-candidatura-detalhe> -->

    <app-mais-detalhe-vaga [vagaSelected]="maisDetalheVagas" (onCloseModal)="showDetalhe=false"></app-mais-detalhe-vaga>
    }
  </ng-template>
</p-drawer>

<p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">

  <form [formGroup]="form" class="p-fluid grid">
    <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
      <label>{{ filter.placeholder }}</label>

      <!-- Se for dropdown -->
      <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
        [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
        [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue">
      </p-select>

      <!-- Se for texto -->
      <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
        [placeholder]="filter.placeholder" class="w-full" />
    </div>
  </form>


  <div class="flex items-center justify-content-between">
    <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
    <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
  </div>
</p-dialog>
